var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditMovie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m156-830.666 76.333 156.333h127L283-830.666h85.333l76.334 156.333h128l-77.333-156.333h86.333L658-674.333h127l-76.333-156.333h94.667q44.099 0 75.382 31.983Q910-766.7 910-724v488q0 42.425-31.284 74.212Q847.433-130 803.334-130H156.666q-43.824 0-74.912-30.104-31.087-30.104-31.087-73.562V-724q0-42.975 30.817-74.654Q112.3-830.333 156-830.666Zm.666 262.998V-236h646.668v-331.668H156.666Zm0 0V-236v-331.668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMovie);
export default __webpack_public_path__ + "static/media/edit-movie.8a15b465a7d0b247e467f327580f7712.svg";
export { ForwardRef as ReactComponent };